
export function createId(obj) {
    let stringId = "";
    for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) {
            stringId += "." + obj[key];
        }
    }
    return stringId ? stringId.substring(1) : "any";
}

export function checkParams(type, destination, fn) {
    if (type == undefined || typeof type !== "string") {
        console.log(
            "Listener type is \"undefined\" or not have actual 'type' for subscribe"
        );
        return false;
    }

    if (destination == undefined || typeof destination !== "object") {
        console.log(
            "Listener destination is \"undefined\" or not have actual 'type' for subscribe"
        );
        return false;
    }

    if (typeof fn !== "function") {
        console.log("Listener is not a function for subscribe!");
        return false;
    }
    return true;
}
